import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from './../services/login.service';

@Injectable({
  providedIn: 'root'
})
export class LoginActivateGuard implements CanActivate {

  constructor(private loginService: LoginService, private router: Router) { }

  //TODO HABRÁ QUE ACCEDER AL ROL DE CADA USUARIO (CLIENTE, GESTOR O IMPROECO) PARA PODER DAR ACCESO A LAS RUTAS DE LOS PORTALES QUE CORRESPONDA
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
      if(Object.keys(this.loginService.getUserToken()).length === 0){
        this.router.navigate(['']);
        return false
      }
      return true
  }
  
}
